export default [
  {
    "id": "mat-enem-0560",
    "numero": 2060,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "A caixa-d'água de uma casa tem a forma de um \nparalelepípedo reto-retângulo e possui dimen-\nsões externas (comprimento, largura e altura) \nde, respectivamente, 4,0 m, 3,0 m e 2,5 m. É \nnecessária a impermeabilização de todas as \nfaces externas dessa caixa, incluindo a tampa. \nO fornecedor do impermeabilizante informou ao \ndono da casa que seu produto é fornecido em \ngalões, de capacidade igual a 4,0 litros. Infor-\nmou, ainda, que cada litro impermeabiliza uma \nárea de 17.700 cm2 e são necessárias 3 de-\nmãos de produto para garantir um bom resulta-\ndo. \n \nCom essas informações, para obter um bom \nresultado no trabalho de impermeabilização, o \ndono da casa precisará comprar um número \nmínimo de galões para a execução desse servi-\nço igual a: \n \nA) 9. \nB) 13. \nC) 19. \nD) 25. \nE) 45.",
    "alternativas": {
      "C": "19.",
      "D": "25.",
      "E": "45.",
      "B": "13."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 560,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0561",
    "numero": 2061,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Em uma cidade, os impostos que incidem sobre \no consumo de energia elétrica residencial são \nde 30% sobre o custo do consumo mensal. O \nvalor total da conta a ser paga no mês é o valor \ncobrado pelo consumo acrescido dos impostos. \n \nConsiderando x o valor total da conta mensal de \numa determinada residência e y o valor dos \nimpostos, qual é a expressão algébrica que \nrelaciona x e y? \n \nA) y = 0,3x/1,3  \nB) y = 0,3x \nC) y = x/1,3 \nD) y = 1,3x/0,3  \nE) y = 0,7x",
    "alternativas": {
      "A": "y = 0,3x/1,3",
      "C": "y = x/1,3",
      "D": "y = 1,3x/0,3",
      "E": "y = 0,7x"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 561,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0562",
    "numero": 2062,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Um cliente fez um orçamento com uma cozi-\nnheira para comprar 10 centos de quibe e 15 \ncentos de coxinha e o valor total foi de R$ \n680,00. Ao finalizar a encomenda, decidiu au-\nmentar as quantidades de salgados e acabou \ncomprando 20 centos de quibe e 30 centos de \ncoxinha. Com isso, ele conseguiu um desconto \nde 10% no preço do cento do quibe e 15% no \npreço do cento de coxinhas, e o valor total da \ncompra ficou em R$ 1.182,00. \n \nDe acordo com esses dados, qual foi o valor \nque o cliente pagou pelo cento da coxinha? \n \nA) R$ 23,40 \nB) R$ 23,80 \nC) R$ 24,90 \nD) R$ 25,30 \nE) R$ 37,80",
    "alternativas": {
      "A": "R$ 23,40",
      "B": "R$ 23,80",
      "D": "R$ 25,30",
      "E": "R$ 37,80"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 562,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0563",
    "numero": 2063,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Uma pessoa usa um programa de computador \nque descreve o desenho da onda sonora cor-\nrespondente a um som escolhido. A equação da \nonda é dada, num sistema de coordenadas \ncartesianas, por y = a ⋅ sen[b(x + c)], em que os \nparâmetros a, b, c são positivos. O programa \npermite ao usuário provocar mudanças no som, \nao fazer alterações nos valores desses parâme-\ntros. A pessoa deseja tornar o som mais agudo \ne, para isso, deve diminuir o período da onda. \n \nO(s) único(s) parâmetro(s) que necessita(m) ser \nalterado(s) é(são): \n \nA) a. \nB) b. \nC) c. \nD) a e b. \nE) b e c.",
    "alternativas": {
      "B": "b.",
      "C": "c.",
      "E": "b e c.",
      "A": "a."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 563,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0564",
    "numero": 2064,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Os sistemas de cobrança dos serviços de táxi \nnas cidades A e B são distintos. Uma corrida de \ntáxi na cidade A é calculada pelo valor fixo da \nbandeirada, que é de R$ 3,45, mais R$ 2,05 por \nquilômetro rodado. Na cidade B, a corrida é \ncalculada pelo valor fixo da bandeirada, que é \nde R$ 3,60, mais R$ 1,90 por quilômetro roda-\ndo. \n \nUma pessoa utilizou o serviço de táxi nas duas \ncidades para percorrer a mesma distância de 6 \nkm. \n \nQual o valor que mais se aproxima da diferença, \nem reais, entre as médias do custo por quilôme-\ntro rodado ao final das duas corridas? \n \nA) 0,75 \nB) 0,45 \nC) 0,38 \nD) 0,33 \nE) 0,13",
    "alternativas": {
      "B": "0,45",
      "C": "0,38",
      "D": "0,33",
      "E": "0,13"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 564,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0565",
    "numero": 2065,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "A figura mostra os preços da gasolina no Brasil \ne nos Estados Unidos (EUA), feita a conversão \npara reais, considerando o preço total de venda \nao consumidor (abaixo dos nomes dos países) e \nos valores das parcelas correspondentes à refi-\nnaria, aos tributos e à distribuição e revenda. \n \n \n \nNote que, considerando apenas a parte corres-\npondente à refinaria, o preço da gasolina vendi-\nda no Brasil é inferior ao preço cobrado nos \nEstados Unidos, mas os tributos, a distribuição \ne a revenda aumentam o preço final de venda \nnos postos brasileiros. \n \nSuponha que fosse tomada a decisão de se \ndiminuir o preço final de venda nos postos brasi-\nleiros, sem alterar a parcela do preço da gasoli-\nna vendida na refinaria, de modo que o preço \nfinal se iguale ao cobrado nos postos dos Esta-\ndos Unidos. \n \nO percentual mais aproximado de redução dos \nvalores em tributos, distribuição e revenda seria: \n \nA) 29. \nB) 44. \nC) 56. \nD) 63. \nE) 80.",
    "alternativas": {
      "E": "80.",
      "B": "44.",
      "C": "56.",
      "D": "63."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 565,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0566",
    "numero": 2066,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Uma revista publicará os dados, apresentados \nno gráfico, sobre como os tipos sanguíneos \nestão distribuídos entre a população brasileira. \nContudo, o editor dessa revista solicitou que \nesse gráfico seja publicado na forma de setores, \nem que cada grupo esteja representado por um \nsetor circular. \n \n \nO ângulo do maior desses setores medirá, em \ngraus, \n \nA) 108,0. \nB) 122,4. \nC) 129,6. \nD) 151,2. \nE) 154,8.",
    "alternativas": {
      "D": "151,2.",
      "E": "154,8.",
      "A": "108,0.",
      "C": "129,6."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 566,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0567",
    "numero": 2067,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "A vazão de água (em m3/h) em tubulações pode \nser medida pelo produto da área da seção \ntransversal por onde passa a água (em m2) pela \nvelocidade da água (em m/h). Uma companhia \nde saneamento abastece uma indústria utilizan-\ndo uma tubulação cilíndrica de raio r, cuja vazão \nda água enche um reservatório em 4 horas. \nPara se adaptar às novas normas técnicas, a \ncompanhia deve duplicar o raio da tubulação, \nmantendo a velocidade da água e mesmo mate-\nrial. \n \nQual o tempo esperado para encher o mesmo \nreservatório, após a adaptação às novas nor-\nmas? \n \nA) 1 hora \nB) 2 horas \nC) 4 horas \nD) 8 horas \nE) 16 horas",
    "alternativas": {
      "D": "8 horas",
      "E": "16 horas",
      "A": "1 hora",
      "B": "2 horas"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 567,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0568",
    "numero": 2068,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Pesquisas indicam que o número de bactérias X \né duplicado a cada quarto de hora. Um aluno \nresolveu fazer uma observação para verificar a \nveracidade dessa afirmação. Ele usou uma po-\npulação inicial de 105 bactérias X e encerrou a \nobservação ao final de uma hora. \n \nSuponha que a observação do aluno tenha con-\nfirmado que o número de bactérias X se duplica \na cada quarto de hora. \nApós uma hora do início do período de observa-\nção desse aluno, o número de bactérias X foi \nde: \n \nA) 2-2 ⋅ 105 \nB) 2-1 ⋅ 105 \nC) 22 ⋅ 105 \nD) 23 ⋅ 105 \nE) 24 ⋅ 105",
    "alternativas": {
      "A": "2-2 ⋅ 105",
      "B": "2-1 ⋅ 105",
      "C": "22 ⋅ 105",
      "E": "24 ⋅ 105"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 568,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0569",
    "numero": 2069,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Os salários, em reais, dos funcionários de uma \nempresa são distribuídos conforme o quadro: \n \n \n \nA mediana dos valores dos salários dessa em-\npresa é, em reais, \n \nA) 622,00. \nB) 933,00. \nC) 1.244,00. \nD) 2.021,50. \nE) 2.799,00.",
    "alternativas": {
      "D": "2.021,50.",
      "A": "622,00.",
      "B": "933,00.",
      "C": "1.244,00."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 569,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0570",
    "numero": 2070,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Um ciclista participará de uma competição e \ntreinará alguns dias da seguinte maneira: no \nprimeiro dia, pedalará 60km; no segundo dia, a \nmesma distância do primeiro mais r km; no ter-\nceiro dia, a mesma distância do segundo mais r \nkm; e, assim, sucessivamente, sempre peda-\nlando a mesma distância do dia anterior mais r \nkm. No último dia, ele deverá percorrer 180km, \ncompletando o treinamento com um total de \n1560km. \n \nA distância r que o ciclista deverá pedalar a \nmais a cada dia, em km, é: \n \nA) 3. \nB) 7. \nC) 10. \nD) 13. \nE) 20.",
    "alternativas": {
      "B": "7.",
      "C": "10.",
      "D": "13.",
      "E": "20."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 570,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0571",
    "numero": 2071,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Para fazer um pião, brinquedo muito apreciado \npelas crianças, um artesão utilizará o torno me-\ncânico para trabalhar num pedaço de madeira \nem formato de cilindro reto, cujas medidas do \ndiâmetro e da altura estão ilustradas na Figura \n1. A parte de cima desse pião será uma semies-\nfera, e a parte de baixo, um cone com altura 4 \ncm, conforme Figura 2. O vértice do cone deve-\nrá coincidir com o centro da base do cilindro. \n \n \nO artesão deseja fazer um pião com a maior \naltura que esse pedaço de madeira possa pro-\nporcionar e de modo a minimizar a quantidade \nde madeira a ser descartada. \n \nDados: \nO volume de uma esfera de raio r é \n4\n3 ⋅ 𝜋 ⋅ r3; \n \nO volume do cilindro de altura h e área da base \nS é S ⋅ h; \n \nO volume do cone de altura h e área da base S \né \n1\n3 ⋅ S ⋅ h; \n \nPor simplicidade, aproxime 𝜋 para 3. \n \nA quantidade de madeira descartada, em cen-\ntímetros cúbicos, é: \n \nA) 45 \nB) 48 \nC) 72 \nD) 90 \nE) 99",
    "alternativas": {
      "E": "99",
      "A": "45",
      "C": "72",
      "D": "90"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 571,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0572",
    "numero": 2072,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Para as pessoas que não gostam de correr \ngrandes riscos no mercado financeiro, a aplica-\nção em caderneta de poupança é indicada, pois, \nconforme a tabela (período 2005 até 2011), a \nrentabilidade apresentou pequena variação. \n \n \n \nCom base nos dados da tabela, a mediana dos \npercentuais de rentabilidade, no período obser-\nvado, é igual a: \nA) 6,2. \nB) 6,5. \nC) 6,6. \nD) 6,8. \nE) 7,0.",
    "alternativas": {
      "B": "6,5.",
      "D": "6,8.",
      "E": "7,0.",
      "A": "6,2."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 572,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0573",
    "numero": 2073,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Uma pessoa comprou um aquário em forma de \num paralelepípedo retângulo reto, com 40cm de \ncomprimento, 15cm de largura e 20cm de altura. \nChegando em casa, colocou no aquário uma \nquantidade de água igual à metade de sua ca-\npacidade. A seguir, para enfeitá-lo, irá colocar \npedrinhas coloridas, de volume igual a 50cm3 \ncada, que ficarão totalmente submersas no \naquário. \n \nApós a colocação das pedrinhas, o nível da \nágua deverá ficar a 6cm do topo do aquário. O \nnúmero de pedrinhas a serem colocadas deve \nser igual a: \n \nA) 48. \nB) 72. \nC) 84. \nD) 120. \nE) 168.",
    "alternativas": {
      "A": "48.",
      "B": "72.",
      "C": "84.",
      "E": "168."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 573,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0574",
    "numero": 2074,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Em 2010, cerca de 3,24 milhões de passageiros \nforam transportados entre os Estados Unidos e \no Brasil, de acordo com dados divulgados pela \nAgência Nacional de Aviação Civil (ANAC). O \ngráfico mostra a distribuição relativa do número \nde passageiros transportados entre o Brasil e os \ncinco destinos mais procurados, dos quais ape-\nnas dois países são europeus: França e Portu-\ngal. \n \n \n \n \nDe acordo com esses dados, o valor mais apro-\nximado para a quantidade total de passageiros \ntransportados em 2010 entre o Brasil e os paí-\nses europeus mostrados no gráfico é: \nA) 874.800. \nB) 1.018.285. \nC) 1.481.142. \nD) 2.499.428. \nE) 3.240.000.",
    "alternativas": {
      "C": "1.481.142.",
      "D": "2.499.428.",
      "A": "874.800.",
      "B": "1.018.285."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 574,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0575",
    "numero": 2075,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "O Brasil desenvolveu técnicas próprias de plan-\ntio e colheita de cana-de-açúcar, tornando-se o \nmaior produtor mundial.  \n \nCultivando novas variedades, foram produzidas, \nna safra 2010/2011, 624 milhões de toneladas \nem 8,1 milhões de hectares.  \n \nHouve um substancial ganho de produtividade \n(em toneladas por hectare) quando se compara \ncom a de décadas atrás, como a da safra \n1974/1975, que foi de 47 toneladas por hectare. \n \nDe acordo com dados apresentados, qual foi o \nvalor mais aproximado da taxa de crescimento \nda produtividade de cana-de-açúcar, por hecta-\nre no Brasil, da safra 1974/1975 para a safra \n2010/2011? \n \nA) 13% \nB) 30% \nC) 64% \nD) 74% \nE) 164%",
    "alternativas": {
      "C": "64%",
      "D": "74%",
      "E": "164%",
      "B": "30%"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 575,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0576",
    "numero": 2076,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "O número de frutos de uma determinada espé-\ncie de planta se distribui de acordo com as pro-\nbabilidades apresentadas no quadro. \n \n \n \nA probabilidade de que, em tal planta, existam, \npelo menos, dois frutos é igual a: \n \nA) 3%. \nB) 7%. \nC) 13%. \nD) 16%. \nE) 20%.",
    "alternativas": {
      "A": "3%.",
      "C": "13%.",
      "D": "16%.",
      "E": "20%."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 576,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0577",
    "numero": 2077,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Um procedimento padrão para aumentar a ca-\npacidade do número de senhas de banco é \nacrescentar mais caracteres a essa senha. Essa \nprática, além de aumentar as possibilidades de \nsenha, gera um aumento na segurança. Deseja-\nse colocar dois novos caracteres na senha de \num banco, um no início e outro no final. Decidiu-\nse que esses novos caracteres devem ser vo-\ngais e o sistema conseguirá diferenciar maiús-\nculas de minúsculas. \n \nCom essa prática, o número de senhas possí-\nveis ficará multiplicado por: \n \nA) 100. \nB) 90. \nC) 80. \nD) 25. \nE) 20.",
    "alternativas": {
      "A": "100.",
      "B": "90.",
      "D": "25.",
      "E": "20."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 577,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0578",
    "numero": 2078,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "André, Carlos e Fábio estudam em uma mesma \nescola e desejam saber quem mora mais perto \nda escola. André mora a cinco vinte avos de um \nquilômetro da escola. Carlos mora a seis quar-\ntos de um quilômetro da escola. Já Fábio mora \na quatro sextos de um quilômetro da escola. \n \nA ordenação dos estudantes de acordo com a \nordem decrescente das distâncias de suas res-\npectivas casas à escola é: \n \nA) André, Carlos e Fábio. \nB) André, Fábio e Carlos. \nC) Carlos, André e Fábio. \nD) Carlos, Fábio e André. \nE) Fábio, Carlos e André.",
    "alternativas": {
      "C": "Carlos, André e Fábio.",
      "D": "Carlos, Fábio e André.",
      "A": "André, Carlos e Fábio.",
      "B": "André, Fábio e Carlos."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 578,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0579",
    "numero": 2079,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Alunos de um curso de engenharia desenvolve-\nram um robô “anfíbio” que executa saltos so-\nmente nas direções norte, sul, leste e oeste. Um \ndos alunos representou a posição inicial desse \nrobô, no plano cartesiano, pela letra P, na ilus-\ntração. \n \nA direção norte-sul é a mesma do eixo y, sendo \nque o sentido norte é o sentido de crescimento \nde y, e a direção leste-oeste é a mesma do eixo \nx, sendo que o sentido leste é o sentido de \ncrescimento de x. \n \nEm seguida, esse aluno deu os seguintes co-\nmandos de movimentação para o robô: 4 norte, \n2 leste e 3 sul, nos quais os coeficientes numé-\nricos representam o número de saltos do robô \nnas direções correspondentes, e cada salto \ncorresponde a uma unidade do plano cartesia-\nno. \n \nDepois de realizar os comandos dados pelo \naluno, a posição do robô, no plano cartesiano, \nserá: \n \nA) (0;2). \nB) (0;3). \nC) (1;2). \nD) (1;4). \nE) (2;1).",
    "alternativas": {
      "A": "(0;2).",
      "B": "(0;3).",
      "C": "(1;2).",
      "D": "(1;4)."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 579,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0580",
    "numero": 2080,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Um clube de futebol abriu inscrições para novos \njogadores. Inscreveram-se 48 candidatos. Para \nrealizar uma boa seleção, deverão ser escolhi-\ndos os que cumpram algumas exigências: os \njogadores deverão ter mais de 14 anos, estatura \nigual ou superior à mínima exigida e bom prepa-\nro físico.  \n \nEntre os candidatos, 7/8 têm mais de 14 anos e \nforam pré-selecionados. Dos pré-selecionados, \n1/2 têm estatura igual ou superior à mínima \nexigida e, destes, 2/3 têm bom preparo físico. \n \nA quantidade de candidatos selecionados pelo \nclube de futebol foi \n \nA) 12. \nB) 14. \nC) 16. \nD) 32. \nE) 42.",
    "alternativas": {
      "E": "42.",
      "B": "14.",
      "C": "16.",
      "D": "32."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 580,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0581",
    "numero": 2081,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Barras de cobre cilíndricas são utilizadas para \nfazer aterramentos elétricos. \n \nDurante a instalação de um chuveiro, uma pes-\nsoa utilizou uma barra de aterramento de densi-\ndade ρ, massa m, diâmetro D=2R e altura h. \n \nPara fazer um novo aterramento, essa pessoa \nutilizou uma barra com a mesma densidade, \nmas com o dobro da massa e o dobro do diâme-\ntro em relação à usada no chuveiro. \nA densidade é dada por ρ = \n𝑚\n𝑉 e o volume da \nbarra cilíndrica é V = 𝜋 ⋅ R2 ⋅ h. \n \nQual a relação da altura da barra utilizada no \nnovo aterramento comparada àquela utilizada \nno aterramento do chuveiro? \n \nA) Quarta parte. \nB) Metade. \nC) Igual. \nD) Dobro. \nE) Quádruplo.",
    "alternativas": {
      "E": "Quádruplo.",
      "A": "Quarta parte.",
      "B": "Metade.",
      "D": "Dobro."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 581,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0582",
    "numero": 2082,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "O Brasil é o quarto produtor mundial de alimen-\ntos, mas aproximadamente 64 toneladas de \ncada 100 toneladas que se produz são perdidas \nao longo da cadeia produtiva.  \n \nEm relação ao total de alimentos produzidos, a \nperda de alimentos é distribuída da seguinte \nforma: 20 toneladas na colheita, 8 toneladas no \ntransporte e armazenamento, 15 toneladas na \nindústria de processamento, 1 tonelada no vare-\njo e 20 toneladas no processamento culinário e \nhábitos alimentares. \n \nDe acordo com os dados apresentados, os ali-\nmentos que são perdidos no processamento \nculinário e nos hábitos alimentares representam \nqual porcentagem em relação ao total de ali-\nmentos que são perdidos no país? \n \nA) 12,28% \nB) 20,00% \nC) 31,25% \nD) 36,00% \nE) 44,00%",
    "alternativas": {
      "E": "44,00%",
      "A": "12,28%",
      "B": "20,00%",
      "C": "31,25%"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 582,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0583",
    "numero": 2083,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Um confeiteiro deseja fazer um bolo cuja receita \nindica a utilização de açúcar e farinha de trigo \nem quantidades fornecidas em gramas.  \n \nEle sabe que uma determinada xícara utilizada \npara medir os ingredientes comporta 120 gra-\nmas de farinha de trigo e que três dessas xíca-\nras de açúcar correspondem, em gramas, a \nquatro de farinha de trigo. \n \nQuantos gramas de açúcar cabem em uma \ndessas xícaras? \n \nA) 30 \nB) 40 \nC) 90 \nD) 160 \nE) 360",
    "alternativas": {
      "D": "160",
      "A": "30",
      "B": "40",
      "C": "90"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 583,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0584",
    "numero": 2084,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Uma fundição de alumínio utiliza, como matéria-\nprima, lingotes de alumínio para a fabricação de \npeças injetadas. Os lingotes são derretidos em \num forno e o alumínio, em estado líquido, é \ninjetado em moldes para se solidificar no forma-\nto desejado. O gráfico indica as curvas de res-\nfriamento do alumínio fundido no molde para \ntrês diferentes fluidos. \n \n \n \nCom a exigência para o desmolde das peças \ninjetadas, qual(is) fluido(s) refrigerante(s) pode-\nrá(ão) ser utilizado(s) no resfriamento? \n \nA) Qualquer um dos fluidos do tipo I, II e III. \nB) Somente os fluidos do tipo II e III. \nC) Somente o fluido do tipo III. \nD) Não será necessário utilizar nenhum fluido \nrefrigerante. \nE) Nenhum dos fluidos refrigerantes indicados \natende às exigências.",
    "alternativas": {
      "B": "Somente os fluidos do tipo II e III.",
      "C": "Somente o fluido do tipo III.",
      "D": "Não será necessário utilizar nenhum fluido refrigerante.",
      "A": "Qualquer um dos fluidos do tipo I, II e III."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 584,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0585",
    "numero": 2085,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "O \nmodelo \nmatemático \ndesenvolvido \npor \nKirschner e Webb descreve a dinâmica da inte-\nração das células não infectadas do sistema \nimunológico humano com os vírus HIV. Os grá-\nficos mostram a evolução no tempo da quanti-\ndade de células não infectadas no sistema imu-\nnológico de cinco diferentes pacientes infecta-\ndos pelo vírus HIV. Quando a população das \ncélulas não infectadas de um sistema imunoló-\ngico é extinta, o paciente infectado fica mais \nsuscetível à morte, caso contraia alguma outra \ndoença. \n \n \n \n \n \n \n \n \nA partir desses dados, o sistema imunológico do \npaciente infectado que ficou mais rapidamente \nsuscetível à morte está representado pelo gráfi-\nco. \n \nA) A. \nB) B. \nC) C. \nD) D. \nE) E.",
    "alternativas": {
      "D": "D.",
      "E": "E.",
      "B": "B.",
      "C": "C."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 585,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0586",
    "numero": 2086,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Ao elaborar um programa de condicionamento \npara um atleta, um preparador físico estipula \nque ele deve correr 1000 metros no primeiro dia \ne, nos dias seguintes, 200 metros a mais do que \ncorreu no dia anterior. O treinador deseja que, \nao final dos dias de treinamento, o atleta tenha \npercorrido, em média, 1700 m por dia. \n \nEsse atleta deve participar desse programa por: \n \nA) 9 dias. \nB) 8 dias. \nC) 5 dias. \nD) 4 dias. \nE) 2 dias.",
    "alternativas": {
      "A": "9 dias.",
      "B": "8 dias.",
      "D": "4 dias.",
      "E": "2 dias."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 586,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0587",
    "numero": 2087,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Um medidor de velocidade funciona com dois \nsensores instalados sob o asfalto. Um micropro-\ncessador recebe os sinais elétricos emitidos \npelos sensores, calculando a velocidade v em \nfunção da distância fixa entre os sensores e o \ntempo gasto durante a passagem distância do \nveículo, assim, v = \ndistância\ntempo . \n \nSe a velocidade for maior do que a máxima \npermitida para a via, um sistema de vídeo é \nacionado para capturar a imagem do veículo \ninfrator. Dois destes medidores estão instalados \nem uma avenida, onde a velocidade máxima \npermitida é de 60 km/h e a distância entre os \nsensores é de meio metro (0,5 m). \n \nUm motorista dirige um carro, nessa avenida, \ncom o velocímetro descalibrado. Ao passar pelo \nprimeiro medidor ele se lembra da existência \ndos medidores, reduzindo em 10 km/h a veloci-\ndade do seu veículo, e passa pelo segundo \nmedidor. Sabe-se que o microprocessador do \nprimeiro medidor registrou que o veículo passou \nentre os sensores em 0,024 segundos e, pela \nlegislação vigente, a multa é classificada em: \n \nMédia: se a velocidade do veículo é maior do \nque 60 km/h e menor ou igual a 72 km/h; \n \nGrave: se a velocidade do veículo é maior do \nque 72 km/h e menor ou igual a 90 km/h; \n \nGravíssima: se a velocidade do veículo é maior \ndo que 90 km/h. (Para transformar a velocidade \nde m/s para km/h multiplica-se por 3,6). \n \nQual(ais) multa(s) esse infrator recebeu? \n \nA) Somente uma média. \nB) Somente uma grave. \nC) Uma grave e uma média. \nD) Somente uma gravíssima. \nE) Duas multas gravíssimas.",
    "alternativas": {
      "A": "Somente uma média.",
      "B": "Somente uma grave.",
      "C": "Uma grave e uma média.",
      "E": "Duas multas gravíssimas."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 587,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0588",
    "numero": 2088,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Uma pessoa, durante sua vida, cometeu crimes, \nsendo, por consequência, condenada a 10 anos \nde cadeia. Ainda no tribunal, o juiz, interessado \nna recuperação dessa pessoa, lhe informou \nacerca da possibilidade que tinha em reduzir \nsua pena, caso se dispusesse a trabalhar na \nmarcenaria da penitenciária. Informou-a que a \ncada 3 dias de trabalho, 1 dia seria \"perdoado\" \nem sua pena.  \n \nImaginando não haver outras formas de pro-\ngressão de pena, e considerando que a pessoa \ntrabalhe todos os dias da semana, quanto tem-\npo ela deverá permanecer presa? \n \nA) Entre 2 e 3 anos. \nB) Entre 3 e 4 anos. \nC) Entre 4 e 5 anos. \nD) Entre 6 e 7 anos. \nE) Entre 7 e 8 anos.",
    "alternativas": {
      "A": "Entre 2 e 3 anos.",
      "B": "Entre 3 e 4 anos.",
      "C": "Entre 4 e 5 anos.",
      "E": "Entre 7 e 8 anos."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 588,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0589",
    "numero": 2089,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "A direção de uma escola comprará lapiseiras \npara distribuir para os seus alunos. Sabe-se que \nx lapiseiras custam y reais.  \n \nO número máximo de lapiseiras que a direção \nda escola conseguirá comprar com z reais é o \nmaior inteiro menor do que, ou igual a: \n \nA) \nx ∙ z\ny  \n \nB) \ny ∙ z\nx  \n \nC) \n z\ny ∙ x \n \nD) \nz\ny \n \nE) \n z\nx",
    "alternativas": {
      "A": "x ∙ z y",
      "B": "y ∙ z x",
      "C": "z y ∙ x",
      "D": "z y"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 589,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0590",
    "numero": 2090,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Uma pesquisa do Instituto de Pesquisa Econômica (Ipea) investigou qual área faz a economia crescer \nmais e quais os maiores responsáveis pela diminuição da desigualdade na distribuição de renda. \n \nA INFLUÊNCIA DE CADA ÁREA NO CRESCIMENTO E NA IGUALDADE \n \n \n \nConsiderando apenas as áreas que contribuem para o crescimento econômico mais do que o investi-\nmento em exportação, qual delas é a que mais influencia para a maior igualdade? \n \nA) Bolsa família. \nB) Educação. \nC) Investimento em construção civil. \nD) Previdência Social. \nE) Saúde.",
    "alternativas": {
      "D": "Previdência Social.",
      "E": "Saúde.",
      "B": "Educação.",
      "C": "Investimento em construção civil."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 590,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0591",
    "numero": 2091,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Até o fim do Império, as mulheres eram tolhidas \nem seu acesso à escola. Já na década de 1930, \no número de meninas e meninos nas institui-\nções de ensino fica igual. Hoje, as mulheres são \nmaioria em todos os níveis de ensino — do fun-\ndamental à pós-graduação. Veja a tabela a se-\nguir: \n \n \n \nConsiderando os dados apresentados tem-se \nque, escolhida ao acaso uma brasileira com \nmais de 10 anos, a probabilidade de que ela \npossua oito anos ou mais de estudos é igual a: \n \nA) 17,1%. \nB) 29,6%. \nC) 34,5%. \nD) 50,5%. \nE) 63,0%.",
    "alternativas": {
      "A": "17,1%.",
      "C": "34,5%.",
      "D": "50,5%.",
      "E": "63,0%."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 591,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0592",
    "numero": 2092,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Um fabricante planeja colocar no mercado duas \nlinhas de cerâmicas para revestimento de pisos. \nDiversas formas possíveis para as cerâmicas \nforam apresentadas e decidiu-se que o conjunto \nP de formas possíveis seria composto apenas \npor figuras poligonais regulares. Duas formas \ngeométricas que fazem parte de P são: \n \nA) triângulo e pentágono. \nB) triângulo e hexágono. \nC) triângulo e octógono. \nD) hexágono e heptágono. \nE) hexágono e octógono.",
    "alternativas": {
      "D": "hexágono e heptágono.",
      "E": "hexágono e octógono.",
      "A": "triângulo e pentágono.",
      "B": "triângulo e hexágono."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 592,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0593",
    "numero": 2093,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Ao alugar um carro, o locatário precisa pagar \nR$60,00 por dia, e mais R$1,50 por quilômetro \nrodado. Para facilitar, as locadoras podem fazer \numa relação entre o valor a ser pago P, em \nreais, em função dos quilômetros rodados, re-\npresentado por x.  \n \nQual das expressões abaixo representa o valor \npago pelos locatários em função dos quilôme-\ntros rodados? \n \nA) P = 61,50 + 1,50x \nB) P = 60x + 1,50 \nC) P = 60 + 1,50x \nD) P = 61,50x \nE) P = 1,50x",
    "alternativas": {
      "C": "P = 60 + 1,50x",
      "E": "P = 1,50x",
      "A": "P = 61,50 + 1,50x",
      "B": "P = 60x + 1,50"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 593,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0594",
    "numero": 2094,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Estudo com funcionários que trabalham como \ncaixas de supermercado revelou que metade \ndeles apresentou sinais de infecção urinária. A \nmaioria fica até 5 horas sem beber água e sem \nurinar. Segundo a pesquisadora Thalita Galindo, \né necessário ingerir água diariamente e o ideal \nde consumo de água diário seria ingerir 35 milili-\ntros de água para cada quilo de peso.  \n \nSabe-se que uma pessoa pesando 80 kg con-\nsome 6 galões de 20 litros de água em 60 dias. \nPara que essa pessoa atinja a ideal ingestão \ndiária de água, a quantidade mínima de litros de \nágua que ela deve acrescentar à sua ingestão \ndiária média, no mesmo período de dias, deve \nser de: \n \nA) 4,8. \nB) 2,8. \nC) 2,0. \nD) 0,8. \nE) 0,4.",
    "alternativas": {
      "C": "2,0.",
      "D": "0,8.",
      "A": "4,8.",
      "B": "2,8."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 594,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0595",
    "numero": 2095,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "A empresa E fornece linhas para telefones celu-\nlares da Companhia de Telefonia X a dois de \nseus funcionários. Os funcionários 1 e 2 usam, \nem média, 170 minutos e 195 minutos mensais, \nem ligações, respectivamente.  \n \nO plano das linhas desses celulares possui uma \nfranquia de 90 minutos mensais (ou seja, 90 \nminutos de ligações grátis a cada mês), e custo \nde R$ 0,20 por minuto adicional, além de um \ncusto fixo de R$ 30,00 mensais.  \n \nA companhia X lançou novos planos que podem \nbaratear o custo da empresa E com esses celu-\nlares e ofereceu-lhes, com preços mostrados a \nseguir: \n \n \n \nMas, por contrato, E só pode migrar uma das \ncontas para um novo plano, enquanto a outra \nprecisa continuar no plano em que está. \n \nDe modo a ter o menor custo possível com os \npagamentos dessas contas de celulares, qual é \na melhor atitude a ser tomada pela empresa E \nem relação às ofertas descritas? \nA) Fornecer o Plano Dourado para o funcionário 1. \nB) Fornecer o Plano Parceria para o funcionário 1. \nC) Fornecer o Plano Dourado para o funcionário 2. \nD) Fornecer o Plano Parceria para o funcionário 2. \nE) Manter os planos atuais.",
    "alternativas": {
      "D": "Fornecer o Plano Parceria para o funcionário 2.",
      "E": "Manter os planos atuais.",
      "B": "Fornecer o Plano Parceria para o funcionário 1.",
      "C": "Fornecer o Plano Dourado para o funcionário 2."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 595,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0596",
    "numero": 2096,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Um pequeno comerciante pretende aplicar \nR$60.000,00 em ações na Bolsa de Valores. O \nquadro seguinte traz algumas das opções de \ninvestimento. \n \n \n \nDentre as opções apresentadas no quadro, a \nmelhor aplicação para esse montante de dinhei-\nro é: \n \nA) BBBT \nB) BGT Capital \nC) IKPQ \nD) JGPF \nE) WWWW",
    "alternativas": {
      "D": "JGPF",
      "E": "WWWW",
      "A": "BBBT",
      "B": "BGT Capital"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 596,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0597",
    "numero": 2097,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Uma pessoa precisa comprar creme dental. Ao \nentrar em um supermercado, encontra uma \nmarca em promoção, conforme o quadro se-\nguinte: \n \n \n \nPensando em economizar seu dinheiro, resolve \nlevar a embalagem de número: \n \nA) 1. \nB) 2. \nC) 3. \nD) 4. \nE) 5.",
    "alternativas": {
      "A": "1.",
      "B": "2.",
      "D": "4.",
      "E": "5."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 597,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0600",
    "numero": 2100,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "O governo, num programa de moradia, tem por \nobjetivo construir 1 milhão de habitações, em \nparceria com estados, municípios e iniciativa \nprivada.  \n \nUm dos modelos de casa popular proposto por \nconstrutoras deve apresentar 45 m2 e deve ser \ncolocado piso de cerâmica em toda sua a área \ninterna.  \n \nSupondo que serão construídas 100 mil casas \ndesse tipo, desprezando-se as larguras das \nparedes e portas, o número de peças de cerâ-\nmica de dimensões 20cm x 20cm utilizadas \nserá: \n \nA) 11,25 mil. \nB) 180 mil. \nC) 225 mil. \nD) 22.500 mil. \nE) 112.500 mil.",
    "alternativas": {
      "B": "180 mil.",
      "C": "225 mil.",
      "D": "22.500 mil.",
      "E": "112.500 mil."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 600,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0601",
    "numero": 2101,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "O gelo marinho no Ártico está em sua segunda \nmenor extensão já registrada: 5,56 milhões de \nkm2. Essa medida foi feita com o auxílio de saté-\nlites no dia 14 de agosto de 2011 e é apenas \n220 mil km2 maior do que a baixa recorde de \n2007. \n \nDe acordo com esses dados, a menor extensão \nterritorial do gelo marinho registrada no Ártico \nem 2007, em metros quadrados, foi: \n \nA) 214,44 x 103 \nB) 5,34 x 106 \nC) 5,34 x 109 \nD) 5,34 x 1012 \nE) 214,44 x 1012",
    "alternativas": {
      "D": "5,34 x 1012",
      "E": "214,44 x 1012",
      "A": "214,44 x 103",
      "C": "5,34 x 109"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 601,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];